<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findMyCustomerVisitList.action"
                    ref="intranetVisitRecordTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.intranetVisitRecordTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="id"
            prop="id">
        </el-table-column>
        <el-table-column
            label="沟通方式"
            prop="contactType">
        </el-table-column>
        <el-table-column
            label="备注"
            prop="content">
        </el-table-column>
        <el-table-column
            label="创建时间"
           >
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetVisitRecord',
  data: function () {
    return {
      queryParams: {
        businessId: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.businessId = query.businessId
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetVisitRecordTable.search()
    }
  },
  filters: {

    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '正在收车'
          break
        case 2:
          str = '排队收车'
          break
        case 3:
          str = '放弃收车'
          break
        case 4:
          str = '成功收车'
          break
        case 5:
          str = '锁定看车'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
